// Module
var code = `<div class="modal-backdrop" uib-modal-animation-class="fade" modal-in-class="in" ng-style="{'z-index': 1040 + (index && 1 || 0) + index*10}"></div>`;
// Exports
export default code;